/**
 * travelPosters — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const travelPostersPack: ToilePack = {
    slug: 'travel-posters',
    category: 'travel',
    name: 'Travel posters',
    tagline: tagline('posters', 'destinations', 'styles'),
    chips: chips('destinations', 'styles'),
    ratio: PORTRAIT,
    readings: [
        {key: 'paris', label: 'Paris', subject: 'zinc rooftops and chimney pots, the iron tower through morning haze'},
        {key: 'kyoto', label: 'Kyoto', subject: 'a vermilion torii path up a wooded hill, maples turning red'},
        {key: 'patagonia', label: 'Patagonia', subject: 'jagged granite spires above a glacial lake, wind-bent trees'},
    ],
    styles: [
        {key: 'railway', label: 'Vintage railway', style: 'vintage railway poster, flat airbrushed gradients', palette: 'limited period palette', framing: 'vertical poster, slab-serif name plate'},
        {key: 'geometric', label: 'Minimal geometric', style: 'minimal geometric, a few flat overlapping shapes', palette: 'three colors, wide empty space', framing: 'vertical poster, name at the bottom'},
        {key: 'painterly', label: 'Painterly', style: 'painterly, visible gouache brushwork', palette: 'layered atmospheric color', framing: 'vertical poster, name at the bottom'},
    ],
    directions: ['Marrakech instead', 'at golden hour', 'with a bolder title plate'],
}
